var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loader",class:{ 'show-loader' : _vm.isActive }},[_c('div',{staticClass:"spinning-loader loader-lg active"})])
}
var staticRenderFns = []

export { render, staticRenderFns }